import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ["total", "giftBookQtyCounter", "giftBookQtyHiddenField", "donationCounter", "nextBtn", "prevBtn", "totalContainer", "submitBtn", "spinner"];

  connect() {
    this.currentStep = this.element.querySelector(".step");
    this.originalTotal = parseFloat(this.totalTarget.dataset.total);
    this.giftBookStepTotal = 0.0;
    this.donationStepTotal = 0.0;
    this.donationAmount = 0.0;

    this.prevBtnTarget.classList.add("invisible");

    this.showFirstStep();
  }

  showFirstStep() {
    this.element.querySelector(".step").classList.remove("hidden");
    this.currentStep = this.element.querySelector(".step");
  }
  

  loadNextStep() {
    var nextStep = this.currentStep.nextElementSibling;
    if (nextStep == null || nextStep.classList.contains("step") == false) return;
    this.currentStep.classList.add("hidden");
    nextStep.classList.remove("hidden");
    this.currentStep = nextStep;

    this.checkNavigationBtnsVisibility(nextStep);


    
    

  }

  loadPrevStep() {
    var prevStep = this.currentStep.previousElementSibling;
    if (prevStep == null || prevStep.classList.contains("step") == false) return;
    this.currentStep.classList.add("hidden");
    prevStep.classList.remove("hidden");
    this.currentStep = prevStep;

    this.checkNavigationBtnsVisibility(prevStep);

  }

  checkNavigationBtnsVisibility(stepElement) {

    if (this.element.querySelector(".step") == this.currentStep) {
      this.prevBtnTarget.classList.add("invisible");
    }
    
    if (stepElement.nextElementSibling == null || stepElement.nextElementSibling.classList.contains("step") == false) {
      this.nextBtnTarget.classList.add("invisible");
    } else {
      this.nextBtnTarget.classList.remove("invisible");
    }

    if (stepElement.previousElementSibling == null || stepElement.previousElementSibling.classList.contains("step") == false) {
      this.prevBtnTarget.classList.add("invisible");
    } else {
      this.prevBtnTarget.classList.remove("invisible");
    }

  }

  updateGiftBookQty(updateAction) {

    this.totalContainerTarget.classList.add("neon-text");

    setTimeout(() => {
      this.totalContainerTarget.classList.remove("neon-text");
    }, 3000);


    var currentQty = parseInt(this.giftBookQtyCounterTarget.innerText)
    var currentTotal = parseFloat(this.totalTarget.dataset.total);

    var newQty = updateAction == "increase" ? currentQty+1 : currentQty -1;
    var newTotal = updateAction == "increase" ? currentTotal+10.0 : currentTotal-10.0;

    if (currentQty == 0 && updateAction == "decrease") return;

    this.giftBookQtyCounterTarget.innerText = newQty;
    this.giftBookQtyHiddenFieldTarget.value = newQty;

    this.totalTarget.innerText = `${parseFloat(newTotal).toFixed(2).toString().replace(".", ",")} €`
    this.totalTarget.dataset.total = newTotal;
    
    // var diff = parseFloat(this.totalTarget.dataset.total) - parseFloat(this.donationStepTotal);
    
    // this.giftBookStepTotal = parseFloat(this.totalTarget.dataset.total) - diff;

  }

  increaseGiftBookQty() {
    this.updateGiftBookQty("increase");
  }

  decreaseGiftBookQty() {
    this.updateGiftBookQty("decrease");
  }
  

  updateTotalWithDonation() {

    // var currentTotal = parseFloat(this.giftBookStepTotal);
    var currentTotal = parseFloat(this.totalTarget.dataset.total);
    this.donationAmount = parseFloat(this.donationCounterTarget.value || 0.0)

    var newTotal = currentTotal+this.donationAmount;
    
    this.totalTarget.innerText = `${parseFloat((newTotal)).toFixed(2).toString().replace(".", ",")} €`
    

    // this.totalTarget.dataset.total = newTotal;


    // this.donationStepTotal = this.totalTarget.dataset.total;
    


    

  }


  showSpinner() {
    this.spinnerTarget.classList.remove("hidden");
    setTimeout(() => {
      this.submitBtnTarget.disabled = true;
    }, 100);
  }


}